<template>
  <el-dialog title="关联流程" :visible.sync="show" width="1200px" top="2vh" :close-on-click-modal="false" append-to-body destroy-on-close>
    <div class="w100 po-r">
      <div class="flex-box">
        <SiftComp v-if="siftData.length" class="flex-1" ref="sift" :siftData="siftData" :each-num="siftData.length" :loading="loading"></SiftComp>
        <div>
          <el-button type="primary" icon="el-icon-search" @click="initPage">查询</el-button>
        </div>
      </div>

      <el-table class="mt10 my-table" header-cell-class-name="my-table-head" row-class-name="cu-p" border stripe :data="list" height="calc(100vh - 10vh - 240px)" @row-click="showIframe">
        <el-table-column align="center" prop="serialNum" label="流水号" width="80px"></el-table-column>
        <el-table-column align="center" prop="processName" label="流程名称" width="120px"></el-table-column>
        <el-table-column prop="processTitle" label="工作名称/文号"></el-table-column>
        <el-table-column align="center" prop="username" label="发起人" width="140px"></el-table-column>
        <el-table-column align="center" prop="createTime" label="发起时间" width="180px">
          <template slot-scope="scope">{{ scope.row.createTime | filterDate("yyyy-MM-dd hh:mm") }}</template>
        </el-table-column>
        <el-table-column align="center" label="是否关联" width="100px" v-if="canEdit">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.ISRELATED" key="ISRELATED1">是</span>
            <span class="grey" v-else key="ISRELATED1">否</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100px" v-if="canEdit">
          <template slot-scope="scope">
            <span class="grey cu-p" v-if="scope.row.ISRELATED" key="ISRELATED" @click.stop="setRelate(scope.row)">取消关联</span>
            <span class="green cu-p" v-else key="ISRELATED" @click.stop="setRelate(scope.row)">设置关联</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="w100 mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination background @size-change="initPage" @current-change="fetchList" :page-sizes="[10, 20, 30, 50, 100]" :current-page.sync="pageNum" :page-size.sync="pageSize" layout="sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>

    <IframeView2 ref="IframeView2" />
  </el-dialog>
</template>

<script>
import SiftComp from "@/components/sift/SiftComp";
import IframeView2 from "./IframeView2";

export default {
  name: "ProcessDialog",
  props: {},
  components: {
    SiftComp,
    IframeView2,
  },
  data() {
    return {
      show: false,
      loading: false,

      canEdit: false,
      fetchUrl: "",

      siftData: [],
      processId: "",
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
    };
  },
  methods: {
    setRelate(item) {
      this.loading = true;
      this.$http
        .post(
          "/process/updateRelatedProcess",
          this.$qs.stringify({
            operationType: item.ISRELATED ? "remove" : "add",
            processId: this.processId,
            id: item.id,
            relatedProcessId: item.processInstId,
          })
        )
        .then(({ data }) => {
          if (data.RetCode) {
            this.$message.success("设置成功");
            this.fetchList();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchSiftData() {
      this.loading = true;
      this.$http
        .get("/process/getQueryCondition")
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.siftData = data.resData.siftData;
            this.$nextTick(() => {
              this.initPage();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchList() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.getSiftValue(true);
      }
      obj.processId = this.processId;
      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;

      this.loading = true;
      this.$http
        .get(this.fetchUrl, {
          params: obj,
        })
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.list = data.resData.list;
            this.total = data.resData.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    initPage() {
      this.list = [];
      this.pageNum = 1;
      this.fetchList();
    },
    showView(processId, canEdit) {
      this.processId = processId;
      this.canEdit = canEdit;
      this.fetchUrl = this.canEdit
        ? "/process/getUserProcessData"
        : "/process/getRelatedProcess";
      this.show = true;

      this.fetchSiftData();
    },
    showIframe(item) {
      if (item.ext5 == "del") {
        this.$alert("该流程已被删除", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$refs.IframeView2.showIframe(item.formUrl, item.processTitle);
    },
  },
  watch: {},
};
</script>

<style>
.theme-blue .el-dialog__body {
  padding: 10px 20px;
}
</style>
